import React, {Component} from 'react';
import AppUtils from '../../apputils';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import ResourcesPage from './resources';


class resources extends Component{
    // constructor(){
    //     super()
    // }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }


    render(){
        return(
            <div>
            <ResourcesPage {...this.props} HandleRouting={this.HandleRouting}/>
            </div>
        )
    }
}


export const Resources = PnkConnect(resources , '')